import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-simple-inner-html-modal',
  templateUrl: './simple-inner-html-modal.component.html',
  styleUrls: ['./simple-inner-html-modal.component.scss'],
})
export class SimpleInnerHtmlModalComponent implements OnInit {

  @Input()
  title: string;

  @Input()
  iob: string;


  constructor(private modalController: ModalController) {
  }

  ngOnInit() {
  }

  onClose() {
    this.modalController.dismiss();
  }
}
